import React, { useState, useEffect } from 'react';
import moment from 'moment';

import Rating from 'components/Rating';

import {
  MainCardBox,
  ProPhoto,
  ProName,
  ProBusiness,
  RatingRow,
  RatingCount,
  ProText,
} from '../styles.js';

const ProInfoCardHeader = ({ proProfile }) => (
    <MainCardBox>
      <ProPhoto cache={false} src={proProfile.profile_picture} alt="Pro Photo" />
      <ProName>{proProfile.name}</ProName>
      <RatingRow>
        <Rating initialRating={proProfile.rating} readonly />
        <RatingCount>{`(${proProfile.rating_list ? proProfile.rating_list.length : ''})`}</RatingCount>
      </RatingRow>
      <ProBusiness>{`${proProfile.deals} negócios fechados`}</ProBusiness>
      <ProText>{proProfile.validated_at ? `${moment(proProfile.validated_at).fromNow()} no Triider` : '' }</ProText>
    </MainCardBox>
  );

export default ProInfoCardHeader;
